import PropTypes from "prop-types";

import { WrapperContainer, Modal, FlexContainers } from "../../components";
import { Ring } from "@uiball/loaders";
import { colors } from "../../consts";
import { LoadingText } from "./styled";

const LoadingModal = ({ id, active, text }) => {
  return (
    <Modal id={id} active={active} closable={false}>
      <WrapperContainer Container={FlexContainers.FlexColumn} gap={20} width={300} pt={24} pb={10}>
        <Ring color={colors.RAISIN_100} size={38} lineWeight={5} speed={2} />

        <LoadingText>{text}</LoadingText>
      </WrapperContainer>
    </Modal>
  );
};

LoadingModal.propTypes = {
  id: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  text: PropTypes.string.isRequired
};

export default LoadingModal;
